import type { AlpineComponent } from 'alpinejs'
import Swiper from 'swiper'
import { Pagination, Navigation, A11y, Mousewheel } from 'swiper/modules'
import 'swiper/css'

export function ProductSlider(): AlpineComponent<{
  swiper: Swiper | undefined
  init(): void
  discard(): void
}> {
  return {
    swiper: undefined,

    init() {
      this.swiper = new Swiper(this.$refs.slider, {
        modules: [Pagination, Navigation, A11y, Mousewheel],
        slidesPerView: 1.25,
        breakpoints: {
          500: {
            slidesPerView: 1.5,
          },
          649: {
            slidesPerView: 2.5,
            slidesPerGroup: 2,
          },
          1024: {
            slidesPerView: 3.5,
            slidesPerGroup: 3,
          },
          1500: {
            slidesPerView: 4.5,
            slidesPerGroup: 4,
          },
          2000: {
            slidesPerView: 5.5,
            slidesPerGroup: 5,
          },
        },
        slidesOffsetBefore: 32,
        slidesOffsetAfter: 32,
        spaceBetween: 24,
        grabCursor: true,
        navigation: {
          nextEl: this.$refs.next,
          prevEl: this.$refs.prev,
          disabledClass: 'opacity-50 cursor-not-allowed',
        },
        pagination: {
          el: this.$refs.pagination,
          type: 'progressbar',
          clickable: true,
        },
        mousewheel: {
          forceToAxis: true,
        },
        observer: true,
        observeParents: true,
      })
    },

    discard() {
      this.swiper && this.swiper.destroy()
    },
  }
}
